import React from 'react'
import PropTypes from 'prop-types'
import { Col, Descriptions, Row } from 'antd'
import {
  formatCountAndRatio,
  formatMetricCount,
  formatMetricPercent,
  getMetricRatio,
} from '../../../utils'
import { renderValidationMetricItem } from './render-validation-metric'

const ValidationEntityMetrics = ({ metrics, showPathWordCountRatio }) => (
  <Row gutter={[16, 16]}>
    <Col xs={24} md={12} xl={8}>
      <Descriptions bordered size="small" column={1}>
        {renderValidationMetricItem(
          'Average total similarity',
          formatMetricPercent(metrics.totalSimilarity),
        )}
        {renderValidationMetricItem(
          'Identity similarity',
          formatMetricPercent(metrics.identitySimilarity),
        )}
        {renderValidationMetricItem(
          'Content similarity',
          formatMetricPercent(metrics.contentSimilarity),
        )}
        {renderValidationMetricItem(
          'Word-count ratio',
          formatMetricPercent(metrics.wordCountRatio),
        )}
        {renderValidationMetricItem(
          'Character-count ratio',
          formatMetricPercent(metrics.charCountRatio),
        )}
        {showPathWordCountRatio &&
          renderValidationMetricItem(
            'Path word-count ratio',
            formatMetricPercent(metrics.fieldMetrics?.path?.wordCountRatio),
          )}
      </Descriptions>
    </Col>
    <Col xs={24} md={12} xl={8}>
      <Descriptions bordered size="small" column={1}>
        {renderValidationMetricItem(
          'Matched items (ratio)',
          formatCountAndRatio(metrics.matchedCount, metrics.recall),
        )}
        {renderValidationMetricItem(
          'Exact items (rate)',
          formatCountAndRatio(metrics.exactCount, metrics.exactMatchRate),
        )}
        {renderValidationMetricItem(
          'Similar items (rate)',
          formatCountAndRatio(metrics.similarCount, metrics.similarMatchRate),
        )}
        {renderValidationMetricItem(
          'Missing items (ratio)',
          formatCountAndRatio(
            metrics.missingCount,
            getMetricRatio(metrics.missingCount, metrics.idealCount),
          ),
        )}
        {renderValidationMetricItem(
          'New items (ratio)',
          formatCountAndRatio(
            metrics.newCount,
            getMetricRatio(metrics.newCount, metrics.currentCount),
          ),
        )}
      </Descriptions>
    </Col>
    <Col xs={24} md={12} xl={8}>
      <Descriptions bordered size="small" column={1}>
        {renderValidationMetricItem(
          'Total ideal items',
          formatMetricCount(metrics.idealCount),
        )}
        {renderValidationMetricItem(
          'Total current items',
          formatMetricCount(metrics.currentCount),
        )}
      </Descriptions>
    </Col>
  </Row>
)

ValidationEntityMetrics.propTypes = {
  metrics: PropTypes.object,
  showPathWordCountRatio: PropTypes.bool,
}

ValidationEntityMetrics.defaultProps = {
  metrics: {},
  showPathWordCountRatio: false,
}

export default ValidationEntityMetrics
